import { FormEntity } from "components/FormEntity";
import Loading from "components/Loading";
import Dashboard from "components/Template/Dashboard";

import ArrowLeft from "icons/arrow-circle-left-green.svg";
import React, { Fragment, useState } from "react";
import { ToastContainer } from "react-toastify";

type Props = {};

const EntityEdit: React.FC<Props> = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingPlans, setLoadingPlans] = useState<boolean>(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");

  return (
    <Dashboard
      icon={ArrowLeft}
      title={name}
      breadcrumb={[
        {
          name: "Entity Management",
          active: false,
          path: "/entity-management",
        },
        {
          name: name,
          active: false,
          path: `/entity-management/${id}/details`,
        },
        { name: "Edit", active: true },
      ]}
      children={
        <Fragment>
          <Loading loading={loading || loadingPlans} />
          <FormEntity
            setLoading={setLoading}
            setLoadingPlans={setLoadingPlans}
            id={id}
            name={name}
            setName={setName}
            setId={setId}
          />
          <ToastContainer />
        </Fragment>
      }
    />
  );
};

export default EntityEdit;
